import {Box} from '@primer/styled-react'
import {graphql, useFragment} from 'react-relay'

import type {Reactions$key} from './__generated__/Reactions.graphql'
import styles from './Reactions.module.css'

export const ReactionsQuery = graphql`
  fragment Reactions on Reactable {
    reactionGroups {
      content
      reactors {
        totalCount
      }
    }
  }
`

type Props = {
  dataKey: Reactions$key
  reactionEmojiToDisplay: {reaction: string; reactionEmoji: string}
  showCompactDensity?: boolean
}

export const Reactions = ({dataKey, reactionEmojiToDisplay, showCompactDensity = false}: Props) => {
  const data = useFragment(ReactionsQuery, dataKey)
  const totalReactionCount =
    data.reactionGroups?.filter(e => e.content === reactionEmojiToDisplay.reaction)[0]?.reactors.totalCount || 0

  if (!reactionEmojiToDisplay?.reactionEmoji || totalReactionCount === 0) {
    return null
  }

  return (
    <Box
      sx={{
        minWidth: showCompactDensity ? 0 : '45px',
        ml: showCompactDensity ? 0 : 3,
      }}
      className={styles.reactionsContainer}
    >
      {totalReactionCount > 0 && (
        <>
          <span>{reactionEmojiToDisplay.reactionEmoji}</span>
          <span>{totalReactionCount}</span>
        </>
      )}
    </Box>
  )
}

try{ Reactions.displayName ||= 'Reactions' } catch {}